module.exports = __webpack_public_path__ + "img/airplane.5c83c47f.svg";